var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-input", {
    ref: "input",
    staticClass: "placeholder-italic",
    attrs: {
      "hide-underline": "",
      placeholder: _vm.placeholder,
      readonly: _vm.readonly
    },
    on: {
      blur: _vm.handleSubmitNewValue,
      click: _vm.handleInputClick,
      keydown: [
        function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.handleSubmitNewValue($event)
        },
        function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
          ) {
            return null
          }
          return _vm.handleCancelEdit($event)
        }
      ]
    },
    model: {
      value: _vm.inputValue,
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }